/* eslint-disable */
import "./UI/dist/assets/css/app.min.css";
import "bootstrap/dist/js/bootstrap.min";
